import React from 'react'
import { SmlsButton, SmlsModal } from '@smiles/smiles-ui-kit-react'
import { ModalBody } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import { usePasswordLockModal } from '../../../context/PasswordLockContext'

export function DefaultPasswordLockModal() {
    const { t } = useTranslation("login_page")

    const { passwordLockModal } = usePasswordLockModal()
    const { hasModalOpen, passwordLockCount, closeModal } = passwordLockModal
    
    return (
      <SmlsModal
        isOpen={hasModalOpen && [1,2,3].includes(passwordLockCount)}
        type="right"
        toggle={closeModal}
        onExit={closeModal}
        className="smls-register-error-modal modal-response-status"
      >
        <ModalBody className="smls-modal-body">
          <div className="smls-modal-header">
            <h4>{t('incorrect_data.title')}</h4>
          </div>
          <div className="smls-modal-text">
            <p>{t('incorrect_data.subtitle')}</p>
          </div>

          <div className="btns-modal-response">
            <SmlsButton className="primary-btn-modal" id="btn_gotIt" onClick={closeModal} text={t('incorrect_data.button')} />
          </div>
        </ModalBody>
      </SmlsModal>
    )
}